import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { ReceivedItemVm } from './received-item.vm';

export class GetReceivedItemsVm extends PageResponseVm<ReceivedItemVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ReceivedItemVm)
  @ValidateNested({ each: true })
  objects: ReceivedItemVm[];
}
